import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from '../../../components/comm/ConfirmModal';
import URL from '../../../constants/url';
import style from './ActivityLevelChange.module.css';
import iconActivity01 from '../../../images/common/i_activity_01.svg';
import iconActivity02 from '../../../images/common/i_activity_02.svg';
import iconActivity03 from '../../../images/common/i_activity_03.svg';
import axiosApi from '../../../api/daonAxios';

const ACTIVITY_LEVELS = [
    { value: 'SD', icon: iconActivity01, label: '거의 없음', desc: '주로 앉아서 생활' }, // 비활동적
    { value: 'AT', icon: iconActivity02, label: '보통 활동', desc: '일상적인 움직임' }, // 활동적
    { value: 'VA', icon: iconActivity03, label: '활발한 활동', desc: '많은 신체 활동' }, // 매우 활동적
];

const ActivityLevelChange = ({ onSave }) => {
    const navigate = useNavigate();
    const [selected, setSelected] = useState();
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    const handleSelect = useCallback((value) => {
        setSelected(value);
    }, []);

    const handleSaveClick = useCallback(() => {
        if (!selected) return;
        setIsConfirmOpen(true);
    }, [selected]);

    const handleConfirm = useCallback(() => {
        setIsConfirmOpen(false);
        savePatntPaCd();
    }, [selected, onSave]);

    const handleCancel = useCallback(() => {
        setIsConfirmOpen(false);
    }, []);

    useEffect(() => {
        getPatntPaCd();
    },[]);
    
    const getPatntPaCd = useCallback(async () => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.get('/setting/patnt/paCd',requestOption)
        .then((res) => {
            const result = res.data.result || '';
            setSelected(result);

        })
        .catch(error => {
            console.error(error);
        }).finally(() => {
        })

    }, []);

    const savePatntPaCd = useCallback(async () => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
            // params : {
            //     paCd : selected,
            // },
        };

        console.log(selected)

        // await axiosApi.put('/diet/changeFoodLensMyFood', {foodLensId : foodLensId, myFoodCnddteId : myFoodCnddteId}, requestOption)
        await axiosApi.put('/setting/patnt/paCd',{paCd : selected},requestOption)
        .then((res) => {
            const result = res.data.result || '';
            navigate(URL.APP_SETTINGS);
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {
        })

    }, [selected]);



    return (
        <div className={style.page}>
            {/* 헤더 */}
            <div className={style.header}>
                <button type="button" className={style.backBtn} onClick={() => navigate(-1)} aria-label="뒤로">
                    <span className={style.backIcon} />
                </button>
                <h1 className={style.title}>신체 활동량 변경</h1>
            </div>

            {/* 안내 문구 */}
            <p className={style.guide}>
                {loginUser?.usrNm}님에게 꼭 맞는 권장 칼로리와 운동 기준을<br />
                계산해 드릴게요.
            </p>

            {/* 활동량 선택 */}
            <div className={style.cardList} role="radiogroup" aria-label="신체 활동량 선택">
                {ACTIVITY_LEVELS.map((lv) => {
                    const active = selected === lv.value;
                    return (
                        <button
                            key={lv.value}
                            type="button"
                            role="radio"
                            aria-checked={active}
                            className={style.card}
                            data-active={active}
                            onClick={() => handleSelect(lv.value)}
                        >
                            <span className={style.cardEmoji} aria-hidden="true">
                                <img src={lv.icon} alt="활동량 이미지" />
                            </span>
                            <span className={style.cardLabel}>{lv.label}</span>
                            <span className={style.cardDesc}>{lv.desc}</span>
                        </button>
                    );
                })}
            </div>

            {/* 저장 버튼 */}
            <div className={style.footer}>
                <button
                    type="button"
                    className={style.saveBtn}
                    disabled={!selected}
                    onClick={handleSaveClick}
                >
                    저장
                </button>
            </div>

            <ConfirmModal
                open={isConfirmOpen}
                title={'신체 활동량을\n변경하시겠습니까?'}
                message={'활동량에 따라 칼로리와\n운동 기준이 함께 변경됩니다.'}
                cancelText={'아니오'}
                confirmText={'네'}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </div>
    );
};

export default ActivityLevelChange;